<template>
  <NotificationBar ref="notificationBar"/>
  <UserBarVue/>

  <div id="main-body">

    <div id="hero-section" class="section">
      <!-- Headline: A clear, compelling statement about what your app does. -->
      <h1>Welcome to Film Lab Assistant</h1>

      <!-- Subheadline: Briefly elaborate on the main headline with a key benefit or unique selling point. -->
      <h2>Seamlessly connect with your favorite film labs for a better film development and scanning experience.</h2>

      <!-- Visual Element: An eye-catching image, graphic, or video that represents your app. -->
      <div class="FRNW" style="justify-content: space-between; margin-top: 20px;">
        <div class="FRNW order-page-img-container" style="width: 48%;">
          <img class="order-page-img" src="../../public/kramericaFilmLabOrderPageScreenShot.png" alt="Order page example" style="border-radius: 8px; box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);">
        </div>
        <div class="FRNW screenshot-text-div">
          <p>Create a customized order page that streamlines ordering and payment with integrations like Square. Tailor dropdowns and options to meet your lab's unique needs for a personalized experience.</p>
        </div>
      </div>

      <div class="FRNW" style="justify-content: space-between; margin-top: 20px;">
        <div class="FRNW order-page-img-container" style="width: 48%;">
          <img class="order-page-img" src="../../public/fla_reports_example.png" alt="Reports example" style="border-radius: 8px; box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);">
        </div>
        <div class="FRNW screenshot-text-div">
          <p>Easily track how many orders are coming in and see a breakdown by type and format. Get a clear view of how orders are changing over time.</p>
        </div>
      </div>

      <!-- Call-to-Action (CTA): Encourage visitors to take action (e.g., "Try for Free", "Learn More"). -->
      <div style="margin-top: 30px; text-align: center;">
        <h2>Getting Started is Easy!</h2>
        <p>Click on the "Create User" button in the navigation bar to begin. <strong>Note:</strong> If you’re a film lab, remember to select the "Film Lab" checkbox during account creation. After signing up, verify your email and you’ll be ready to log in. Happy shooting!</p>
        <button @click="openCreateAccountPage" class="cta-button" >Create Account</button>
      </div>
    </div>


    <div id="features-benefits" class="section">
      <h2>Why Use Film Lab Assistant?</h2>
      <div id="benefits-photographers">
        <h3>Benefits for Photographers:</h3>
        <ul>
          <li>Streamlines the process by replacing paper forms, saving time and reducing errors.</li>
          <li>Account creation allows photographers to track orders, favorite labs, and save checkout preferences.</li>
          <li>Enables users to monitor the progress of their film development and scanning jobs.</li>
          <li>Receive instant notifications from labs when orders are completed and ready for pickup or download.</li>
        </ul>
      </div>
      <div id="benefits-labs">
        <h3>Benefits for Film Labs:</h3>
        <ul>
          <li>Simplifies the creation of online order pages with customizable options tailored to each lab.</li>
          <li>Integrates with existing payment systems like Square, providing seamless transactions.</li>
          <li>Allows customers to pay conveniently when completing their order forms.</li>
          <li>Eliminates the need for paper forms, reducing errors associated with manual data entry.</li>
          <li>Provides a real-time dashboard to track orders at various stages of the development process.</li>
          <li>Enables labs to send notifications to customers about order status, such as when scans are uploaded or negatives are ready for pickup.</li>
        </ul>
      </div>
    </div>



    <div id="how-it-works" class="section">
      <h2>How It Works</h2>
      <div>
        <ul>
          <li><b>Film Labs</b> create accounts and set up order pages showcasing their available services. These order pages can be easily linked to the lab’s existing website.</li>
          <li><b>Users</b> place orders directly from the lab’s order page. They can choose to order as a guest or create an account. Having an account allows users to favorite labs for quicker access in the future.</li>
          <li><b>Order Management:</b> Once an order is placed, it appears in the lab’s order queue. Labs can filter the queue by order status and search using text strings for efficient management.</li>
          <li><b>Notifications:</b> Labs can update order statuses and send notifications to customers via email through the Film Lab Assistant app, keeping customers informed about their orders.</li>
        </ul>
      </div>
      <div id="about-section-flow-chart-div">
        <!-- this image comes from https://docs.google.com/presentation/d/1ijvu4owvYzo1asElb1MV8hRr6aSBCF0ImKDhPtcsNzI/edit#slide=id.p -->
        <img id="about-section-flow-chart" src="../../public/aboutSectionFlowChart.png" alt="flow chart">
      </div>
    </div>



    <!-- <div id="testimonials-reviews">
      Quotes or feedback from users who have found your app useful.
      Include the name, role, or a small image of the user to make the testimonial more credible.
    </div> -->


    <div id="about-us-why-choose-us" class="section">
      <h2>About</h2>
      <div>
        <p>Film Lab Assistant was created by Mitch McCracken during a break from his software development career. Inspired by a conversation with a local film lab, this app aims to help independent labs operate more efficiently. It's a passion project designed to support those pursuing their own ventures.</p>
      </div>
      <div>
        <p>While features like those in Shopify exist, Film Lab Assistant offers a streamlined, user-friendly experience tailored specifically for film labs and photographers. We are committed to continually improving the app based on user feedback and needs.</p>
      </div>
    </div>


    <div id="pricing" class="section">
      <h2>Pricing</h2>
      <div>
        <p>Currently, Film Lab Assistant is free for all users. Our hosting costs are minimal at this time, allowing us to offer this service without charge. If our costs increase in the future, we will notify all users in advance before implementing any pricing changes.</p>
      </div>
    </div>


    <!-- <div id="call-to-action"></div> -->


    <div id="footer" class="section">
      <div>
        Have questions, suggestions, or feedback? Feel free to email us at filmlabassistant@gmail.com.
      </div>

    </div>


    <!-- <div id="additional-sections"></div> -->

  </div>
</template>

<script>
import NotificationBar from '../components/NotificationBar.vue';
import UserBarVue from '../components/basicComponents/UserBar.vue';


export default {
  name: 'App',
  components: {
    NotificationBar,
    UserBarVue
  },
  props: {},
  data() {
    return {}
  },
  methods: {
    test() {
      console.log('test')
      window.notificationBarInstance.showNotification( 'test');
    },

    openCreateAccountPage() {
      const href = window.location.href;
      window.open(href + 'createUser', '_blank')
    },
  }, 
  mounted() {
    // for dev purposes
    window.notificationBarInstance = this.$refs.notificationBar;
    window.showNotification = this.$refs.notificationBar.showNotification;
    const NOTIFICATION = this.$refs.notificationBar;
    this.notificationFunc = NOTIFICATION?.showNotification;
    // added for debugging, TODO: understand if we want to keep this
    window.App = this;
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: white;
  position: relative;
  /* width: 100%; */
}

.red {
  color: red;
  background: rgb(255, 187, 187);
  font-weight: bold;
}

#main-body {
  display: flex;
  flex-direction: column;
  flex: 1;
}

.order-page-img-container {
  /* display: flex; */
  justify-content: center;
  align-items: center;
}

.order-page-img{
  max-width: 100%;
  height: auto;
  border-radius: var(--fla-border-radius);
  border: 2px solid gray;
}

#about-section-flow-chart{
  width: 80%;
  border-radius: var(--fla-border-radius);
  border: 2px solid gray;
}

.section {
  background-color: var(--fla-gray);
  border-radius: var(--fla-border-radius);
  margin: .5rem 0 ;
  padding: .5rem ;
}

.cta-button {
  padding: .25rem .5rem;
  color: black;
  background-color: gainsboro;
  border: 1px solid gray;
  border-radius: var(--fla-border-radius);
  font-weight: bold;
  cursor: pointer;
  transition: all .3s;
}
.cta-button:hover{
  color: white;
  background-color: var(--fla-btn-hover-blue);
}

.screenshot-text-div {
  width: 48%;
  padding: 1px;
  align-items: center;
}

</style>
